import React, { useEffect, useState } from "react"
import './Home.css'
import Sidebar from "../components/sidebar"
import { Link, useNavigate } from "react-router-dom";
import Topbar from "../components/topbar";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axios from "axios";
import { errorMessage } from "../hooks/UserLogs";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const [ListInvoices, setListInvoices] = useState([]);
  const [ListAgencies, setListAgencies] = useState([]);
  const [ListAgents, setListAgents] = useState([]);
  const [ListStaffs, setListStaffs] = useState([]);
  const [nbCustomer, setNbCustomer] = useState(0);
  const [nbAgent, setNbAgent] = useState(0);
  const [nbStaff, setNbStaff] = useState(0);
  const [errMsg, setErrorMsg] = useState("Une erreure s'est produite!!");
    const [showError, setShowError] = useState(false);
  const bUrl = process.env.REACT_APP_B_URL;

  const axiosInstance = axios.create({
                withCredentials: true,
              }) 
              
  const getStatistics = async () => {
    let ulr = "/owner-agent/statistics";

    const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true);
        
      } else {
        setShowError(true);
      }
      setIsLoading(false)

    });

    if (response) {
      if (response.status == 401) {
        navigate('/backoffice/login');
      }
      
      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        setErrorMsg(msg);
        setShowError(true);
      }else{
        setNbAgent(response.data.body.nbAgent);
        setNbStaff(response.data.body.nbStaff);
        setNbCustomer(response.data.body.nbCustomer);
      }
      setIsLoading(false);
    }
  }

  const handleCloseError = () => {
    setShowError(false);
  }

  const getListInvoices = async () => {
    let ulr = "/biller-invoice?page=1&limit=6";

    const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true);
        if (response.status == 401) {
          navigate('/backoffice/login');
        }
      } else {
        setShowError(true);
      }
      setIsLoading(false)

    });
    
    if (response) {
      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        setErrorMsg(msg);
        setShowError(true);
      }else{
        setListInvoices(response.data.body);
      }

      setIsLoading(false);

      if (response.status == 401) {
        navigate('/backoffice/login');
      }
      
    }
  }
  const getListAgencies = async () => {
    let ulr = "/agencies?page=1&limit=6";
    const response = await axiosInstance.get(bUrl + ulr).catch((err) => {
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        setErrorMsg("Vous n'étes pas autorisé à faire cette opération")
        setShowError(true);
        if (response.status == 401) {
          navigate('/backoffice/login');
        }
      } else {
        setShowError(true);
      }
      setIsLoading(false)

    });
    if (response) {
      setListAgencies(response.data.body);
      //setNbAgency(response.data.total)
      setIsLoading(false);
      if (response?.data?.isError) {
        const msg = errorMessage(response?.data?.code)
        setErrorMsg(msg);
        setShowError(true);
      }

      if (response.status == 401) {
        navigate('/backoffice/login');
      }
    }
  }

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', minute: 'numeric', second: 'numeric' }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }
  const data = {
    labels: ['Janvier', 'Fevrier', 'Mars'],
    datasets: [
      {
        label: '369',
        data: [29, 18, 120],
        backgroundColor: '#66AEDE',
        borderColor: 'black',
        borderWith: 1,
      }
    ]
  }
  const options = {

  }

  const navigate = useNavigate();
  useEffect(() => {
    getStatistics();
    //getListInvoices();
    if (sessionStorage.getItem("name") === '' || sessionStorage.getItem("name") === null) {
      //console.log("----------GO GO GO ------------")
      navigate('/backoffice/login');
    }
  }, []);
  return (
    <div className="App">
      <div className="">


        <Sidebar />
        <section className="home ">
          <div className="row mb-2">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="table-content mt-2 mb-2 p-2 text d-flex justify-content-between">
                <div><p className='fw-bold'> </p></div>
                <div><Topbar /></div>
              </div>

              <div className="row home-stats-grid">
                <div className="my-card">
                  <div className="d-flex justify-content-between p-4 text">
                    <div><h1>Marchand: {nbAgent}</h1></div>
                    <div><i className='bx bx-bar-chart colore-icon' ></i></div>
                  </div>
                </div>
                <div className="my-card">
                  <div className="d-flex justify-content-between p-4 text">
                    <div><h1>Client: {nbCustomer}</h1></div>
                    <div><i className='bx bx-bar-chart colore-icon'></i></div>
                  </div>
                </div>
                <div className="my-card">
                  <div className="d-flex justify-content-between p-4 text">
                    <div><h1>Staff: {nbStaff}</h1></div>
                    <div><i className='bx bx-bar-chart colore-icon'></i></div>
                  </div>
                </div>
              </div>
              <div className='row mt-2 home-reports-row'>
                <div className="rapport home-reports-panel d-flex justify-context-center align-item-center p-4">
                  <div className="home-report-grid">
                    <div className="my-card col-3  mt-2">
                      <Link to="/userLogs">
                        <div className="d-flex justify-content-between p-4 text">
                          <div><i className='bx bx-file rapport-icon' ></i></div>
                          <div><h5> Rapport d'audit des utilisateurs</h5></div>
                        </div>
                      </Link>
                    </div>
                    <div className="my-card col-3  mt-2">
                      <Link to="/billerPerAgent">
                        <div className="d-flex justify-content-between p-4 text">
                          <div><i className='bx bx-file rapport-icon' ></i></div>
                          <div><h5> Revenus des ventes d'electricité par marchand</h5></div>
                        </div>
                      </Link>
                    </div>
                    <div className="my-card col-3 mt-2">
                      <Link to="/depotPerAgent">
                        <div className="d-flex justify-content-between p-4 text">
                          <div><i className='bx bx-file rapport-icon' ></i></div>
                          <div><h5> Déposit de crédit par marchand</h5></div>
                        </div>
                      </Link>
                    </div>

                   
                    <div className="my-card col-3 mt-2">
                      <Link to="/depot-per-agency">
                        <div className="d-flex justify-content-between p-4 text">
                          <div><i className='bx bx-file rapport-icon' ></i></div>
                          <div><h5> Déposit de crédit par agence</h5></div>
                        </div>
                      </Link>
                    </div>

                    <div className="my-card col-3 mt-2">
                      <Link to="/agency-balance">
                          <div className="d-flex justify-content-between p-4 text">
                            <div><i className='bx bx-file rapport-icon' ></i></div>
                            <div><h5> Crédit agence et solde disponible</h5></div>
                          </div>
                        </Link>
                    </div>

                    <div className="my-card col-3 mt-2">
                      <Link to="/billerPerPaymentMode">
                          <div className="d-flex justify-content-between p-4 text">
                            <div><i className='bx bx-file rapport-icon' ></i></div>
                            <div><h5> Revenus des ventes d'electricité par mode de paiement</h5></div>
                          </div>
                        </Link>
                    </div>

                    

                    

                <div className="my-card col-3 mt-2">
                      <Link to="/agentBalance">
                        <div className="d-flex justify-content-between p-4 text">
                          <div><i className='bx bx-file rapport-icon' ></i></div>
                          <div><h5> Crédit marchand et solde disponible</h5></div>
                        </div>
                      </Link>
                    </div>
                    <div className="my-card col-3 mt-2">
                      <Link to="/system-logs">
                        <div className="d-flex justify-content-between p-4 text">
                          <div><i className='bx bx-server rapport-icon'></i></div>
                          <div><h5> Fichiers journaux système</h5></div>
                        </div>
                      </Link>
                    </div>
                    <div className="my-card col-3 mt-2">
                      <Link to="/api-group">
                        <div className="d-flex justify-content-between p-4 text">
                          <div><i className='bx bx-bar-chart-alt-2 rapport-icon'></i></div>
                          <div><h5> Statistiques API</h5></div>
                        </div>
                      </Link>
                    </div>
                    <div className="my-card col-3 mt-2">
                      <Link to="/billerGroup">
                        <div className="d-flex justify-content-between p-4 text">
                          <div><i className='bx bx-grid-alt rapport-icon'></i></div>
                          <div><h5>Rapport du total des ventes</h5></div>
                        </div>
                      </Link>
                    </div>
                    </div>
                    </div>

               </div>


              <div>

              </div>

            </div>
            <Modal show={showError} onHide={handleCloseError} className="">
              <Modal.Header closeButton className="bg-danger">
                <Modal.Title>ERREURE</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h5 className='text-danger' style={{ textAlign: 'center' }}>{errMsg}</h5>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseError}>
                  Fermer
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </section>
      </div>
    </div>
  )
}
